<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          User Information
        </CCardHeader>
        <CCardBody>
          <loading :active.sync="isLoading"
          :can-cancel="false"
          :on-cancel="onCancel"
          :is-full-page="fullPage"></loading>
          <CCardHeader>
            <b>First name</b>: {{resources.firstname}}
          </CCardHeader>
          <CCardHeader>
            <b>Last name</b>: {{resources.lastname}}
          </CCardHeader>
          <CCardHeader>
            <b>Email</b>: {{resources.email}}
          </CCardHeader>
        </CCardBody>
      </CCard>
      <CRow>
        <CCol col="6">
          <CCard>
            <CCardHeader>
              Change User Information
            </CCardHeader>
            <CCardBody>
              <CForm @submit.prevent="ChangeUserInformation">
                <CRow>
                  <CCol sm="12">
                    <CInput
                      label="Email"
                      placeholder="Enter your first name"
                      :value="resources.email"
                      type="text"
                      required
                      disabled
                    />
                  </CCol>
                  <CCol sm="12">
                    <CInput
                      label="First name"
                      placeholder="Enter your first name"
                      v-model="changeuserinformation.firstname"
                      type="text"
                    />
                    <div class="login-errors" v-if="$v.changeuserinformation.firstname.$error">
                      <span class="validation-error" v-if="!$v.changeuserinformation.firstname.required">Please Enter your first name</span>
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                      <CInput
                      label="Last name"
                      placeholder="Enter your last name"
                      v-model="changeuserinformation.lastname"
                      type="text"
                    />
                    <div class="login-errors" v-if="$v.changeuserinformation.lastname.$error">
                      <span class="validation-error" v-if="!$v.changeuserinformation.lastname.required">Please Enter your last name</span>
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4" type="submit">Submit</CButton>
                    </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol col="6">
          <CCard>
            <CCardHeader>
              Change User Password
            </CCardHeader>
            <CCardBody>
              <CForm @submit.prevent="ChangeServiceStatus">
                <CRow>
                  <CCol sm="12">
                    <CInput
                      label="Old password"
                      placeholder="Enter your old password"
                      v-model="changepassword.oldpassword"
                      type="password"
                    />
                    <div class="login-errors" v-if="$v.changepassword.oldpassword.$error">
                      <span class="validation-error" v-if="!$v.changepassword.oldpassword.required">Please Enter old Password</span>
                      <span class="validation-error" v-else-if="!$v.changepassword.oldpassword.minlength">Please Enter minimum 6 characters Password</span>
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                      <CInput
                      label="New password"
                      placeholder="Enter your new password"
                      v-model="changepassword.newpassword"
                      type="password"
                    />
                    <div class="login-errors" v-if="$v.changepassword.newpassword.$error">
                      <span class="validation-error" v-if="!$v.changepassword.newpassword.required">Please Enter new Password</span>
                      <span class="validation-error" v-else-if="!$v.changepassword.newpassword.minlength">Please Enter minimum 6 characters Password</span>
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                      <CInput
                      label="Confirm password"
                      placeholder="Enter your confirm password"
                      v-model="changepassword.confirmpassword"
                      type="password"
                    />
                    <div class="login-errors" v-if="$v.changepassword.confirmpassword.$error">
                      <span class="validation-error" v-if="!$v.changepassword.confirmpassword.required">Please Enter confirm Password</span>
                      <span class="validation-error" v-else-if="!$v.changepassword.confirmpassword.sameAs">Confirm Password must be same as New Password</span>
                      <span class="validation-error" v-else-if="!$v.changepassword.confirmpassword.minlength">Please Enter minimum 6 characters Password</span>
                    </div>
                  </CCol>
                  </CRow>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4" type="submit">Submit</CButton>
                    </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import VueNotifications from 'vue-notifications'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
const {
    email,
    required,
    maxLength,
	minLength,
	sameAs
} = require("vuelidate/lib/validators");


export default {
    name: 'Profile',
    data() {
        return {
            showAddBtn: true,
            isLoading: false,
            fullPage: true,
            resources: [],
            columns: ['firstname', 'lastname', 'email'],
            activeOptions: [{id: 0, text: 'Deactive'}, {id: 1, text: 'Active'}],
            selectedOption: '0',
            token: localStorage.getItem('token'),
            tokenChange: JSON.parse(localStorage.getItem('token')),
            userId: JSON.parse(localStorage.getItem('userdata'))._id,
            changepassword: {
              userId: JSON.parse(localStorage.getItem('userdata'))._id,
              oldpassword: "",
              newpassword: "",
              confirmpassword: ""
            },
            changeuserinformation: {
              userId: JSON.parse(localStorage.getItem('userdata'))._id,
              firstname: "",
              lastname: ""
            },
            options: {
              sortable: ['firstname'],
              sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              pagination: {
                chunk: 5,
                edge: false,
                nav: 'scroll'
              }
            },
        }
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    components: {
        Loading
    },
    created() {
        document.title = "Profile";
        this.loadData();
    },
    methods: {
      loadData() {
        this.isLoading = true;
        axios.post(`${API_ADMIN_URL}/profile/`, {}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
          if(response.data.status == 200) {
            this.resources = response.data.data[0];
            this.isLoading = false;
          }
          else {
              localStorage.clear();
              this.isLoading = false;
              this.$router.push('/login');
          }
        })
      },
      ChangeServiceStatus: function() {
        // stop here if form is invalid
        this.$v.changepassword.$touch();
        if (!this.$v.changepassword.$invalid) {
            this.isLoading = true;
            axios.post(`${API_ADMIN_URL}/changePassword/`, this.changepassword, {headers: {'x-access-token': this.tokenChange}}).then(response => {
            if(response.data.status == 200) {
              this.changepassword = {
                userId: JSON.parse(localStorage.getItem('userdata'))._id,
                oldpassword: "",
                newpassword: "",
                confirmpassword: ""
              },
              this.$v.changepassword.$reset()
              this.showSuccessMsg({message: response.data.message});
              this.hideLoader();
              this.loadData();
              this.isLoading = false;
            }
            else if(response.data.status == 400) {
              this.isLoading = false;
              this.showErrorMsg({message: response.data.message});
            }
            else {
                localStorage.clear();
                this.isLoading = false;
                this.$router.push('/login');
            }
            this.isLoading = false;
          });
        }
      },
      ChangeUserInformation: function() {
        // stop here if form is invalid
        this.$v.changeuserinformation.$touch();
        if (!this.$v.changeuserinformation.$invalid) {
          this.isLoading = true;
          axios.post(`${API_ADMIN_URL}/changeUserInformation/`, this.changeuserinformation, {headers: {'x-access-token': this.tokenChange}}).then(response => {
            if(response.data.status == 200) {
              this.changeuserinformation = {
                firstname: "",
                lastname: ""
              },
              this.$v.changeuserinformation.$reset()
              localStorage.removeItem('userdata');
              localStorage.setItem('userdata', JSON.stringify(response.data.data));
              this.showSuccessMsg({message: response.data.message});
              this.hideLoader();
              this.loadData();
              this.isLoading = false;
            }
            else {
                localStorage.clear();
                this.isLoading = false;
                this.$router.push('/login');
            }
            this.isLoading = false;
          });
        }
      },
      onCancel() {
      },
      showLoader: function() {
        this.$isLoading = true;
        this.$emit('loading', true);
      },
      hideLoader: function() {
        this.$isLoading = false;
        this.$emit('loading', false);
      },
      redirectUrls: function(link) {
        window.open(link, '_blank');
      },
    },
    mixins: [validationMixin],
    validations: {
      changepassword:{
        oldpassword: {
                  required,
                  minLength: minLength(6),
              },
        newpassword: {
                  required,
                  minLength: minLength(6),
              },
              confirmpassword: {
                  required,
                  minLength: minLength(6),
                  sameAsPassword: sameAs('newpassword'),
        }
      },
      changeuserinformation:{
        firstname: {
                  required,
              },
        lastname: {
                  required,
              }
      }
    }
}
</script>
